import { useCallback, useEffect, useRef, useState } from 'react';

interface ReturnValue {
  prevState: boolean;
  isActive: boolean;
}

function useTabVisibility(): ReturnValue {
  const prevRef = useRef<boolean>(!document.hidden);

  const [isActive, setActive] = useState<boolean>(!document.hidden);

  const handleVisibility = useCallback(() => {
    setActive(!document.hidden);
  }, []);

  useEffect(() => {
    document.addEventListener('visibilitychange', handleVisibility);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibility);
    };
  }, []);

  useEffect(() => {
    prevRef.current = isActive;
  }, [isActive]);

  return {
    prevState: prevRef.current,
    isActive,
  };
}

export { useTabVisibility };
